import { CSSProperties, forwardRef, useRef } from 'react';
import { Color, Size } from '@vivli/shared/theme';
import { BaseInputFieldComponent } from './base-input-field.component';
import { FormFieldTypeEnum } from '@vivli/shared/infrastructure/enum';
import { IFormField } from '@vivli/shared/infrastructure/interface';

const valueStyle: CSSProperties = {
    paddingTop: '4px',
    border: 'none',
    fontSize: Size.FontSize.Large,
    fontWeight: Size.FontWeight.SemiBold,
    color: Color.DARK_GRAY,
    flex: '1 1 auto',
    resize: 'none',
    borderWidth: 'initial',
    borderStyle: 'none',
    borderColor: 'initial',
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingBottom: '5px',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    width: '100%',
};

const fieldStyle: CSSProperties = {
    minHeight: '27px',
};

interface ReadOnlyFieldComponentProps extends IFormField {
    text: string;
}

//this component has same style as other text components that
// are form-based
export const ReadOnlyFieldComponent = forwardRef((props: ReadOnlyFieldComponentProps, ref) => {
    const textInputRef = useRef<HTMLInputElement>();
    const { text } = props;

    const display = <div style={{ ...valueStyle, cursor: 'pointer' }}>{text}</div>;

    return (
        <BaseInputFieldComponent {...props} type={FormFieldTypeEnum.Text} inputRef={textInputRef}>
            <div style={fieldStyle}>{display}</div>
        </BaseInputFieldComponent>
    );
});
